module.exports = __webpack_public_path__ + "img/JV.e62e4002.png";